import View from "../common/views/HeaderTabsView.js";
import components from "./components.js";
components.define("js-HeaderTabs", View);